<template>
  <v-row>
    <v-col class="pb-0 pt-0" cols="12" md="12" v-if="allowAdd">
      <el-button
        v-if="showAddPrincipal"
        class="mb-3"
        small
        color="primary"
        icon="pridėti"
        :title="mandateData.parent_id ? 'Pridėti perįgaliotoją' : 'Pridėti įgaliotoją'"
        :loading="loading"
        @click.native.stop="newPrincipal()"
      />
    </v-col>
    <v-col class="pb-0 pt-0" cols="12" md="12" v-if="showTogether && persons.length > 1">
      <el-checkbox
          :disabled="togetherDisabled"
          class="mt-0 mb-1"
          style="width: fit-content"
          label="Veikia kartu"
          v-model="mandateData.principals_together"
        />
    </v-col>
    <v-col class="pb-0 pt-0" cols="12" md="12">
      <v-data-table
        class="mb-4 custom-table"
        :loading="loading"
        :headers="headersPrincipals"
        :items-per-page="1000"
        :items="persons"
        :hide-default-footer="true"
        :header-props="{
          sortByText: $t('Rūšiuoti pagal'),
        }"
      >
        <!-- custom templates -->
        <template v-slot:item="{ item, index }">
          <tr>
            <td class="pr-0 pl-2">{{ formatedIndex(index) }}</td>
            <td>{{ item.code || item.iltu_code }}</td>
            <td>{{ item.fullname }}</td>
            <td>{{ item.other_info }}</td>
            <td v-if="!contactLoading"><person-contact-row :item="item"></person-contact-row></td>
            <td>{{ item.person_document_kind_title_lt || ''}}</td>
            <td>
              <template>
                <div class="nowrap">
                  <el-table-action v-if="allowAdd"
                    :item="setEditPrincipals(item)"
                    @editContacts="editContacts(item)"
                    @deleteItem="deleteItem({ item, type: 'principals' })"
                    @addJurRepresenterItem="newJurRepresenter(item)"
                    @showPersonDocument="showPersonDocument(item)"
                  />
                  <el-table-action v-else-if="canEditContacts"
                    :item="setEditContacts(item, index)"
                    @editContacts="editContacts(item)"
                    @showPersonDocument="showPersonDocument(item)"
                  />
                  <el-table-action v-else
                    :item="setShowPersonDocument(item)"
                    @showPersonDocument="showPersonDocument(item)"
                  />
                </div>
              </template>
            </td>
          </tr>
          <template v-for="(representer, subIndex) in item.jur_representers">
            <tr :key="`${item.id}-${subIndex}-representer`">
              <td></td>
              <td style="white-space: nowrap">
                <v-icon>mdi-circle-small</v-icon>
                <span>{{ representer.code || representer.iltu_code }}</span>
              </td>
              <td>{{ representer.fullname }}</td>
              <td v-if="representer.other_info">
                {{
                  `${item.fullname} ${$t('atstovas')} (${
                    representer.other_info
                  })`
                }}
              </td>
              <td v-else>{{ `${item.fullname} ${$t('atstovas')}` }}</td>
              <td v-if="!contactLoading"><person-contact-row :item="representer"></person-contact-row></td>
              <td>
                  <el-table-action v-if="canEditContacts"
                    :item="setEditContacts(representer, subIndex)"
                    @editContacts="editContacts(representer)"
                  />
              </td>
            </tr>
          </template>
        </template>
      </v-data-table>
         <!--  -->
        <div v-if="showDeletedItemList" class="pt-0">
          <h4 class="pb-1">{{$t('Pašalinti perįgaliotojai')}}</h4>
          <v-data-table
            class="mb-4 custom-table"
            :loading="loading"
            :headers="headersPrincipals"
            :items="getDeletedItems"
            :hide-default-footer="true"
            :items-per-page="1000"
            :item-class="rowClass"
            :header-props="{
              sortByText: $t('Rūšiuoti pagal')
            }"
          >
            <template #[`item.contact_row`]="{ item }">
              <person-contact-row :item="item"></person-contact-row>
            </template>
            <template #[`item.actions`]="{ item }">
              <div class="nowrap">
                <el-table-action
                  v-if="!loading"
                  :item="setSubMandateDeletedParams(item)"
                  @addCustomItem="addServiceSubMandate"
                />
              </div>
            </template>
          </v-data-table>
      </div>
    </v-col>
    <!-- modal  -->
    <modal-delete v-if="allowAdd"
      title="Įrašo šalinimas"
      :text="subMandate ? `Pašalinus asmenį nebus išsaugoti redaguoti kontaktiniai duomenys. Ar tikrai norite pašalinti?` : `Ar tikrai norite pašalinti?`"
      v-model="showDelete"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
    <modal-add-person
      v-if="showAddPerson"
      v-model="showAddPerson"
      :modalType="modalType"
      :allowForeignJur="allowForeignJur"
      :additionalData="additionalData"
      @addPersonData="addPerson"
      showForeignerPp
      :checkBeforeAddRaw="isErrorsCorrectionInaccuracies"
      :addRaw="!isErrorsCorrectionInaccuracies"
      mandate
    />
    <modal-contact-form
      v-if="showContactModal"
      v-model="showContactModal"
      :item="selectedContact"
      @reloadContact="reloadContact"
    />
    <modal-person-document
      v-if="showPersonDocumentModal"
      v-model="showPersonDocumentModal"
      :item="selectedPersonDocument"
      :readonly="onlyView"
      upload-mode="array"
      @files-added-to-person="handlePersonDocumentFilesAdded"
      @file-removed-from-person="handlePersonDocumentFileRemoved"
    />
  </v-row>
</template>

<script>
import ModalAddPerson from '@/components/modals/ModalAddPerson'
import ModalDelete from '@/components/modals/ModalDelete'
import ModalContactForm from '@/components/modals/ModalContactForm.vue'
import ModalPersonDocument from '@/components/modals/ModalPersonDocument.vue'
import PersonContactRow from '@/components/iregTableRows/PersonContactRow.vue'
import InJournalTypes from '@/components/constants/inJournalTypes'

export default {
  name: 'PrincipalsForm',
  components: {
    ModalAddPerson,
    ModalDelete,
    ModalContactForm,
    PersonContactRow,
    ModalPersonDocument,
  },
  props: {
    onlyView: Boolean,
    persons: [Array, Object],
    allowAdd: Boolean,
    canEditContacts: Boolean,
    showTogether: Boolean,
    mandateData: Object,
    allowForeignJur: [Boolean, String],
    isSubmandate: Boolean,
    inJournalType: [String],
  },
  data() {
    return {
      showContactModal: false,
      selectedContact: {},
      pageloading: false,
      loading: false,
      showAddPerson: false,
      modalType: null,
      showDelete: false,
      modalDeleteItem: null,
      contactLoading: false,
      showPersonDocumentModal: false,
      selectedPersonDocument: {},
    }
  },
  computed: {
    isErrorsCorrectionInaccuracies() {
      return this.inJournalType == InJournalTypes.TARNYBINIS_APIE_NETIKSLUMUS
    },
    showAddPrincipal(){
      return !(this.subMandate && this.inJournalType == InJournalTypes.PRANESIMAS_APIE_PATVIRTINIMA)
    },
    togetherDisabled() {
      return [
        InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_PASIBAIGIMA,
        InJournalTypes.PRANESIMAS_APIE_PROKUROS_PASIBAIGIMA,
        InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_SUSTABDYMA,
        InJournalTypes.PRANESIMAS_APIE_PROKUROS_SUSTABDYMA,
        InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_SUSTABDYMO_PANAIKINIMA,
        InJournalTypes.PRANESIMAS_APIE_PROKUROS_SUSTABDYMO_PANAIKINIMA
      ].includes(this.inJournalType) || this.lockPrincipalsTogether()
    },
    subMandate() {
      return !!this.mandateData.parent
    },
    showDeletedItemList(){
      return this.subMandate && this.inJournalType == InJournalTypes.PRANESIMAS_APIE_PATVIRTINIMA && this.getDeletedItems.length > 0 && !this.onlyView
    },
    getDeletedItems(){
      let delArray = []
      if(!this.mandateData.parent){
        return delArray
      }
      if (this.mandateData.parent?.parent_id) {
        this.mandateData.parent.sub_representitives.map(item => {
          const index = this.mandateData.principals.findIndex((e) => {
              if (item.amn_id && !item.amn_id.includes('new_id')) {
                return e.amn_id == item.amn_id
              } else if (e.amn_id.includes('new_id')) {
                if (e.type == 'JUR') {
                  return  e.foreigner_code == item.foreigner_code && e.fullname == item.fullname
                } else {
                  return  e.foreigner_code == item.foreigner_code && e.lastname == item.lastname && e.name == item.name && e.birth_date == item.birth_date
                }
              }
            });
          if (index == -1) {
            delArray.push(item)
          }
        })
      } else {
        this.mandateData.parent.representitives.map(item => {
          const index = this.mandateData.principals.findIndex((e) => {
              if (item.amn_id && !item.amn_id.includes('new_id')) {
                return e.amn_id == item.amn_id
              } else if (e.amn_id.includes('new_id')) {
                 if (e.type == 'JUR') {
                  return  e.foreigner_code == item.foreigner_code && e.fullname == item.fullname
                } else {
                  return  e.foreigner_code == item.foreigner_code && e.lastname == item.lastname && e.name == item.name && e.birth_date == item.birth_date
                }
              }
            });
          if (index == -1) {
            delArray.push(item)
          }
        })
      }
      return delArray
    },
    additionalData() {
      return {
        principals: this.persons,
        representitives: this.mandateData.representitives,
        sub_representitives: this.mandateData.sub_representitives,
        };
    },
    headersPrincipals() {
      let headers = [
        {
          text: '',
          align: 'start',
          value: 'index',
          sortable: false,
        },
        {
          text: this.$t('Asmens/ILTU kodas'),
          align: 'start',
          value: 'code',
        },
        {
          text: this.$t('Vardas pavardė / Pavadinimas'),
          align: 'start',
          value: 'fullname',
          width: '18rem',
        },
        {
          text: this.$t('Kita informacija'),
          align: 'start',
          value: 'other_info',
        },
        {
          text: this.$t('Kontaktai'),
          align: 'start',
          value: 'contact_row',
        },
        {
          text: this.$t('Asmens dokumentas'),
          align: 'start',
          value: 'person_document_kind_title_lt',
        },
        {
          text: this.$t('Veiksmai'),
          align: 'start',
          sortable: false,
          value: 'actions',
        },
      ]
      return headers
    },
  },
  methods: {
    lockPrincipalsTogether(){
      if(
        (this.subMandate && (this.mandateData.parent.parent_id ? this.mandateData.parent?.sub_representitives_together : this.mandateData.parent?.representitives_together))
        && this.inJournalType == InJournalTypes.PRANESIMAS_APIE_PATVIRTINIMA
      ) {
          return true
      } else {
        return this.onlyView
      }
    },
    canDeletePrincipals(){
      if(this.inJournalType == InJournalTypes.PRANESIMAS_APIE_PATVIRTINIMA){
        if (this.mandateData.parent?.parent_id) {
          return this.mandateData.parent?.sub_representitives_together || false
        }
        return this.mandateData.parent?.representitives_together || false
      } else {
        return this.onlyView
      }
    },
    rowClass() {
      return `row-red`
    },
    addServiceSubMandate(item){
      this.loading = true
      let formData = item
      formData.dataType = 'principals'
      if (item.amn_id && item.amn_id.includes('new_id')) {
        let newItem = {...item, id: '', mandate_person_id: item.id, canDelete: true, canAddCustom: false};
        this.mandateData.principals.push(newItem)
        this.loading = false
      } else if (item.amn_id) {
        item.canAddCustom = false
        this.mandateData.principals.push(item)
        this.loading = false
      } else {
        let url = `persons/getByAsmCode`
        let personData = {}
        this.$axios
          .post(url, formData)
          .then((res) => {
            personData = res.data.person
            personData.modalType = 'principals'
            this.checkPerson(personData)
          })
          .catch((err) => {
            this.$root.$emit('DATA_ERROR', err)
            this.loading = false
          })
          .finally(() => {

          })
      }
    },
    setSubMandateDeletedParams(item){
      item.canEditContacts = false
      item.canDelete = false
      item.canAddCustom = true
      return item
    },
    checkPerson(personData) {
      let code = personData.code
      let type = personData.type
      let dataType = personData.modalType
      this.$axios
        .post('persons/checkPerson', { code: code, type: type, dataType: dataType })
        .then(() => {
          this.addPerson(personData)
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
          this.loading = false
        })
        .finally(() => {
        })
    },
    reloadContact() {
      this.contactLoading = true;
      this.$nextTick(() => {
        this.contactLoading = false
      })
    },
    newPrincipal() {
      this.modalType = 'principals'
      this.showAddPerson = true
    },
    addPerson(item) {
      // if (item.modalType === 'principals') {
        // add jur_representers
        item.jur_representers = item.signing_persons
        if(this.subMandate){
          let person = this.mandateData.parent.representitives.find((parentItem) => parentItem.amn_id === item.amn_id)
          if(person){
            item.phone_number_prepend = person.phone_number_prepend || '+370'
            item.phone_number = person.phone_number
            item.email_address = person.email_address
          }
        }
        this.persons.push(item)
      // }
      this.showAddPerson = false
      this.loading = false
    },
    formatedIndex(index, subIndex) {
      if (subIndex != undefined) {
        this.persons[index].jur_representers[subIndex].order_no =
          subIndex + 1
        return `${index + 1}.${subIndex + 1}.`
      }
      this.persons[index].order_no = index + 1
      return `${index + 1}.`
    },
    setEditPrincipals(item) {
      this.$set(item, 'addJurRepresenter', false)
      item.canDelete = this.subMandate ? !this.canDeletePrincipals() : this.allowAdd;
      this.$set(item, 'canEditContacts', item.type == 'FIZ' && this.canEditContacts)
      if (!this.subMandate && item.role !== "representitive") {
        this.$set(item, 'showPersonDocument', (item.person_documents && item.person_documents.length) || item.person_document_files || item.person_document_kind_id)
      }
      return item
    },
    setShowPersonDocument(item) {
      if (!this.subMandate && item.role !== "representitive") {
        this.$set(item, 'showPersonDocument', (item.person_documents && item.person_documents.length) || item.person_document_files || item.person_document_kind_id)
      }
      return item
    },
    setEditContacts(item) {
      this.setShowPersonDocument(item)
      this.$set(item, 'canEditContacts', item.type == 'FIZ' && this.canEditContacts)
      item.canDelete = false;
      return item
    },
    showPersonDocument(item) {
      this.selectedPersonDocument = item
      this.showPersonDocumentModal = true
    },
    editContacts(item) {
      item.phone_number_prepend = item.phone_number_prepend || '+370'
      item.phone_number = item.phone_number || ''
      item.email_address = item.email_address || ''
      this.selectedContact = item
      this.showContactModal = true
    },
    deleteItem(item) {
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = this.allowAdd;
    },
    confirmDelete(item) {
      const index = this.additionalData[item.type].findIndex(
        (formItem) => {
          if (formItem.amn_id && formItem.amn_id && formItem.amn_id != 'new_id') {
            return formItem.amn_id === item.item.amn_id
          } else {
            return formItem.amn_id === item.item.amn_id && formItem.fullname === item.item.fullname
          }
        }
      )
      if (index > -1) {
        this.additionalData[item.type].splice(index, 1)
      }
      this.showDelete = false
    },

    handlePersonDocumentFilesAdded(addedFiles) {
      // Files have been added to the person's file array
      // The files are already added to selectedPersonDocument.person_document_files
      // Just show success message
      this.$root.$emit('DATA_SUCCESS', `${addedFiles.length} file(s) added to person document`)
    },

    handlePersonDocumentFileRemoved(removedFile) {
      // File has been removed from the person's file array
      // The file is already removed from selectedPersonDocument.person_document_files
      // Just show success message
      this.$root.$emit('DATA_SUCCESS', 'File removed from person document')
    },
  },
}
</script>

<style>
</style>
